export default "__VITE_ASSET__1LWSyV3n__"